import { BaseTargetScores } from './base-target-scores.model';
import { CustomTargetRating } from './custom-target-rating.model';
import { InstitutionLastActivity } from './institution-last-activity.model';
import { Peer } from './peer.model';
import { PriorityRating } from './priority-rating.enum';
import { TargetHolding } from './target-holding.model';
import { Turnover } from './turnover.enum';

export interface TargetCompany {
  id: number;
  name: string;
  suitabilityScore?: number;
  purchasingPower?: number;
  purchasingPowerCurrency?: number;
  equityAssets?: number;
  stretchPurchasingPower?: number;
  stretchPurchasingPowerCurrency?: number;
  primaryStyle?: string;
  location?: string;
  turnover?: Turnover;
  targetRank?: number;
  priorityRating?: PriorityRating;
  contact?: Contact;
  hasPrimaryContact?: boolean;
  countryExposure?: Exposure;
  industryExposure?: Exposure;
  marketCapExposure?: Exposure;
  isEsg: boolean;
  holding?: TargetHolding;
  esgCategoryNames?: string;
  bestFund?: FundBase;
  peers?: Peer;
  lastActivity?: InstitutionLastActivity;
  systemRatingLastUpdatedDate?: string;
  customTargetRating?: CustomTargetRating;
  orientation?: string;
  activistStatus?: string;
  investmentCenter?: string;
  city?: string;
  investorType?: string;
}

export interface CompanyContact {
  companyId: string;
  companyName: string;
  isPrimaryContact: boolean;
  isPrimaryCompany: boolean;
}

export interface Contact {
  id: string;
  name: string;
  companyId: string;
  isEsg: boolean;
  companyContacts: CompanyContact[];
  email: string;
}

export interface FundBase {
  id: number;
  name: string;
}

export interface Fund extends FundBase {
  isEsg: boolean;
}

export interface FundExpanded extends Fund, BaseTargetScores {
  id: number;
  name: string;
  primaryStyle?: string;
  turnover?: Turnover;
  shares?: number;
  sharesChanges?: number;
  equityAssets?: number;
  isBestFund: boolean;
  sfdr?: number;
}

export interface FundTarget extends Fund, BaseTargetScores {}

export enum Exposure {
  VeryHigh = 'VeryHigh',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  VeryLow = 'VeryLow'
}
